import { useEffect, useState } from "react";
import { useApi, UseApiResponse } from "../use-api";

export const useXStatus = ({
  brandId,
}: {
  brandId?: string;
}): UseApiResponse<{ status: "connected" | "not_connected" }> => {
  const [xStatusResponse, setXStatusResponse] = useState<
    UseApiResponse<{ status: "connected" | "not_connected" }>
  >({
    response: null,
    error: null,
    loading: false,
    reload: () => {},
  });

  const { response, error, loading, reload } = useApi<
    unknown,
    unknown,
    { status: "connected" | "not_connected" }
  >({
    endpoint: `brands/${brandId}/x/status`,
    method: "get",
    lazy: !brandId,
  });

  useEffect(() => {
    if (response !== null || error !== null) {
      setXStatusResponse({ response, error, loading, reload });
    }
  }, [response, error, loading, reload]);

  return xStatusResponse;
};
